import api from './authService';

/** Mennyi lejárt napló van, kategóriánként — a törlés ELŐTTI megmutatáshoz. */
export interface ExpiredDataSummary {
  auditLogs: number;
  clientErrors: number;
  sosAccessLogs: number;
  inactiveDeviceTokens: number;
  auditLogRetentionDays: number;
  clientErrorRetentionDays: number;
  sosAccessLogRetentionDays: number;
  total: number;
}

export interface PurgeResult {
  auditLogsDeleted: number;
  clientErrorsDeleted: number;
  sosAccessLogsDeleted: number;
  deviceTokensDeleted: number;
  total: number;
}

export interface ErasureField {
  field: string;
  currentValue?: string;
}

export interface RetainedRecord {
  record: string;
  count: number;
  reason: string;
}

/** Előnézet: mi tűnik el és mi marad, ha töröljük a felhasználó adatait. */
export interface UserErasurePreview {
  userId: string;
  name: string;
  email: string;
  isActive: boolean;
  alreadyErased: boolean;
  fieldsToErase: ErasureField[];
  retainedRecords: RetainedRecord[];
  hasProfileImage: boolean;
  coachNotesToDelete: number;
  /**
   * [É4, 2026-09-13] A szerver ezt is küldi (`UserErasurePreviewDto.PrivateLessonRequestsToDelete`),
   * de a típusból kimaradt, így az előnézet ELHALLGATTA, hogy a magánóra-igénylések is törlődnek.
   * A törlés VISSZAFORDÍTHATATLAN — az előnézet minden kategóriát mutasson.
   */
  privateLessonRequestsToDelete: number;
}

export interface UserErasureResult {
  userId: string;
  fieldsErased: number;
  coachNotesDeleted: number;
  /** A szerver `UserErasureResultDto.PrivateLessonRequestsDeleted`-je — eddig kimaradt. */
  privateLessonRequestsDeleted: number;
  profileImageDeleted: boolean;
  message: string;
}

export const dataRetentionService = {
  async getExpired(): Promise<ExpiredDataSummary> {
    const response = await api.get('/data-retention/expired');
    return response.data;
  },

  async purgeExpired(): Promise<PurgeResult> {
    const response = await api.post('/data-retention/purge-expired');
    return response.data;
  },

  async previewUserErasure(userId: string): Promise<UserErasurePreview> {
    const response = await api.get(`/data-retention/users/${userId}/erasure-preview`);
    return response.data;
  },

  async eraseUser(userId: string): Promise<UserErasureResult> {
    const response = await api.post(`/data-retention/users/${userId}/erase`);
    return response.data;
  },
};

export default dataRetentionService;
